import styled from "styled-components";
import TextFieldView from "../commons/TextField.view";
import BaseModal from "../modal/Base.modal";
import { useState } from "react";


type WithdrawalProps = {
  onClickCancel: () => void
  onClickConfirm: () => void
}


export default function WithdrawalModal(props: WithdrawalProps) {

  const [isAgree1, setIsAgree1] = useState(false)
  const [isAgree2, setIsAgree2] = useState(false)

  return (
    <BaseModal
      title="정말로 회원 탈퇴할까요?"
      onClickLeftButton={props.onClickCancel}
      onClickRightButton={props.onClickConfirm}
      rightButtonText="회원 탈퇴"
      isDisableRightButton={!isAgree1 || !isAgree2}
    >
      <Withdrawaldiv className="card_middle">
        <p>아래 사항을 확인해 주세요.</p>
        <ul>
          <li>
            <input type="checkbox" id="check1"
              checked={isAgree1}
              onChange={e => setIsAgree1(e.target.checked)}
            />
            <label htmlFor="check1">
              <span className="checkmark" />
              <p>지금 회원을 탈퇴하면, <strong className="red">다시 가입 후 정기자문료를 3회 이상 납부할 때까지</strong> 법률자문 서비스를 제공 받을 수 없습니다.</p>
            </label>
          </li>
          <li>
          <input type="checkbox" id="check2"
            checked={isAgree2}
            onChange={e => setIsAgree2(e.target.checked)}
          />
            <label htmlFor="check2">
              <span className="checkmark" />
              <p>회원 탈퇴는 철회할 수 없습니다.</p>
            </label>
          </li>
        </ul>
      </Withdrawaldiv>
    </BaseModal>
  )
}

const Withdrawaldiv = styled.section`
  max-width: 480px;
  border-top: 1px solid #eee;
  ul{
    margin-top: 24px;
    li + li{
      margin-top: 12px;
    }
  }
`